var _clipPath, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgS2GasMsn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0.0 0.0 518.0 626.0",
    fill: "none",
    stroke: "none",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "p.0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0l518.0 0l0 626.0l-518.0 0l0 -626.0z",
    clipRule: "nonzero"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#p.0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m0 0l518.0 0l0 626.0l-518.0 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "m31.364271 156.23799l0 0c0 -41.66136 33.77321 -75.43457 75.43458 -75.43457l301.72925 0l0 0c20.0065 0 39.193573 7.947548 53.3403 22.094276c14.1467285 14.1467285 22.0943 33.33381 22.0943 53.340294l0 381.94977c0 41.661377 -33.773224 75.43457 -75.4346 75.43457l-301.72925 0c-41.66137 0 -75.43458 -33.773193 -75.43458 -75.43457z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0d6b46",
    strokeWidth: 16,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m31.364271 156.23799l0 0c0 -41.66136 33.77321 -75.43457 75.43458 -75.43457l301.72925 0l0 0c20.0065 0 39.193573 7.947548 53.3403 22.094276c14.1467285 14.1467285 22.0943 33.33381 22.0943 53.340294l0 381.94977c0 41.661377 -33.773224 75.43457 -75.4346 75.43457l-301.72925 0c-41.66137 0 -75.43458 -33.773193 -75.43458 -75.43457z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "m126.43569 26.131453l0 0c0 -6.041914 4.8979416 -10.939852 10.9398575 -10.939852l51.726593 0c2.9014282 0 5.684021 1.1525879 7.7356415 3.2042084c2.0516205 2.0516205 3.2042084 4.834215 3.2042084 7.7356434l0 43.758087c0 6.041916 -4.897934 10.9398575 -10.93985 10.9398575l-51.726593 0c-6.041916 0 -10.9398575 -4.8979416 -10.9398575 -10.9398575z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0d6b46",
    strokeWidth: 16,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m126.43569 26.131453l0 0c0 -6.041914 4.8979416 -10.939852 10.9398575 -10.939852l51.726593 0c2.9014282 0 5.684021 1.1525879 7.7356415 3.2042084c2.0516205 2.0516205 3.2042084 4.834215 3.2042084 7.7356434l0 43.758087c0 6.041916 -4.897934 10.9398575 -10.93985 10.9398575l-51.726593 0c-6.041916 0 -10.9398575 -4.8979416 -10.9398575 -10.9398575z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "m9.068241 401.4735l0 0c0 -3.487732 2.827361 -6.315094 6.3150873 -6.315094l484.56668 0c1.6748657 0 3.281128 0.66534424 4.4654236 1.8496704c1.1843262 1.1842957 1.8496704 2.7905579 1.8496704 4.4654236l0 25.259583c0 3.487732 -2.827362 6.315094 -6.315094 6.315094l-484.56668 0c-3.4877262 0 -6.3150873 -2.827362 -6.3150873 -6.315094z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0d6b46",
    strokeWidth: 12,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m9.068241 401.4735l0 0c0 -3.487732 2.827361 -6.315094 6.3150873 -6.315094l484.56668 0c1.6748657 0 3.281128 0.66534424 4.4654236 1.8496704c1.1843262 1.1842957 1.8496704 2.7905579 1.8496704 4.4654236l0 25.259583c0 3.487732 -2.827362 6.315094 -6.315094 6.315094l-484.56668 0c-3.4877262 0 -6.3150873 -2.827362 -6.3150873 -6.315094z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "m312.0 26.131453l0 0c0 -6.041914 4.897949 -10.939852 10.93985 -10.939852l51.726593 0c2.9014282 0 5.684021 1.1525879 7.7356567 3.2042084c2.0516052 2.0516205 3.204193 4.834215 3.204193 7.7356434l0 43.758087c0 6.041916 -4.8979187 10.9398575 -10.93985 10.9398575l-51.726593 0c-6.0419006 0 -10.93985 -4.8979416 -10.93985 -10.9398575z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0d6b46",
    strokeWidth: 16,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m312.0 26.131453l0 0c0 -6.041914 4.897949 -10.939852 10.93985 -10.939852l51.726593 0c2.9014282 0 5.684021 1.1525879 7.7356567 3.2042084c2.0516052 2.0516205 3.204193 4.834215 3.204193 7.7356434l0 43.758087c0 6.041916 -4.8979187 10.9398575 -10.93985 10.9398575l-51.726593 0c-6.0419006 0 -10.93985 -4.8979416 -10.93985 -10.9398575z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m91.05249 184.8092l0 0c0 -17.583588 14.254318 -31.837906 31.837914 -31.837906l269.55252 0c8.443939 0 16.542023 3.3543396 22.512787 9.325104c5.9707947 5.970764 9.325134 14.068863 9.325134 22.512802l0 127.34781c0 17.583588 -14.2543335 31.83789 -31.837921 31.83789l-269.55252 0c-17.583595 0 -31.837914 -14.254303 -31.837914 -31.83789z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0d6b46",
    strokeWidth: 12,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m91.05249 184.8092l0 0c0 -17.583588 14.254318 -31.837906 31.837914 -31.837906l269.55252 0c8.443939 0 16.542023 3.3543396 22.512787 9.325104c5.9707947 5.970764 9.325134 14.068863 9.325134 22.512802l0 127.34781c0 17.583588 -14.2543335 31.83789 -31.837921 31.83789l-269.55252 0c-17.583595 0 -31.837914 -14.254303 -31.837914 -31.83789z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m132.82152 283.68765l0 16.251984",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0d6b46",
    strokeWidth: 8,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m132.82152 283.68765l0 16.251984",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m148.82152 283.68765l0 16.251984",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0d6b46",
    strokeWidth: 8,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m148.82152 283.68765l0 16.251984",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m185.17323 185.6301l0 0c0 -4.641617 3.7627563 -8.404373 8.404358 -8.404373l113.36449 0c2.2289734 0 4.3666687 0.8854523 5.94281 2.4615784c1.5761108 1.5761261 2.4615784 3.7138062 2.4615784 5.942795l0 33.616455c0 4.6416016 -3.7627869 8.404373 -8.404388 8.404373l-113.36449 0l0 0c-4.6416016 0 -8.404358 -3.7627716 -8.404358 -8.404373z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0d6b46",
    strokeWidth: 8,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m185.17323 185.6301l0 0c0 -4.641617 3.7627563 -8.404373 8.404358 -8.404373l113.36449 0c2.2289734 0 4.3666687 0.8854523 5.94281 2.4615784c1.5761108 1.5761261 2.4615784 3.7138062 2.4615784 5.942795l0 33.616455c0 4.6416016 -3.7627869 8.404373 -8.404388 8.404373l-113.36449 0l0 0c-4.6416016 0 -8.404358 -3.7627716 -8.404358 -8.404373z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m164.82152 283.68765l0 16.251984",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0d6b46",
    strokeWidth: 4,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m164.82152 283.68765l0 16.251984",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m180.82152 283.68765l0 16.251984",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0d6b46",
    strokeWidth: 8,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m180.82152 283.68765l0 16.251984",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m196.82152 283.68765l0 16.251984",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0d6b46",
    strokeWidth: 8,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m196.82152 283.68765l0 16.251984",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m212.82152 283.68765l0 16.251984",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0d6b46",
    strokeWidth: 4,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m212.82152 283.68765l0 16.251984",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m228.82152 283.68765l0 16.251984",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0d6b46",
    strokeWidth: 8,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m228.82152 283.68765l0 16.251984",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m244.82152 283.68765l0 16.251984",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0d6b46",
    strokeWidth: 8,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m244.82152 283.68765l0 16.251984",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m260.82153 283.68765l0 16.251984",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0d6b46",
    strokeWidth: 8,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m260.82153 283.68765l0 16.251984",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m276.82153 283.68765l0 16.251984",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0d6b46",
    strokeWidth: 4,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m276.82153 283.68765l0 16.251984",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m292.82153 283.68765l0 16.251984",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0d6b46",
    strokeWidth: 8,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m292.82153 283.68765l0 16.251984",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m308.82153 283.68765l0 16.251984",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0d6b46",
    strokeWidth: 8,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m308.82153 283.68765l0 16.251984",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m126.43569 48.010498l73.6063 0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0d6b46",
    strokeWidth: 8,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m126.43569 48.010498l73.6063 0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m312.0 48.010498l73.60629 0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0d6b46",
    strokeWidth: 8,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m312.0 48.010498l73.60629 0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m161.00787 315.14435l120.0 1.8582764",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#cc0000",
    strokeWidth: 4,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    strokeDasharray: "4.0,12.0",
    d: "m161.00787 315.14435l120.0 1.8582764",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m147.7769 245.69301l0 0c0 -2.487503 2.0165253 -4.5040283 4.5040283 -4.5040283l192.75572 0c1.1945496 0 2.340149 0.47453308 3.184845 1.3191986c0.8446655 0.8446655 1.3191833 1.9902802 1.3191833 3.1848297l0 18.015549c0 2.4875183 -2.01651 4.5040283 -4.5040283 4.5040283l-192.75572 0c-2.487503 0 -4.5040283 -2.01651 -4.5040283 -4.5040283z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0d6b46",
    strokeWidth: 8,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m147.7769 245.69301l0 0c0 -2.487503 2.0165253 -4.5040283 4.5040283 -4.5040283l192.75572 0c1.1945496 0 2.340149 0.47453308 3.184845 1.3191986c0.8446655 0.8446655 1.3191833 1.9902802 1.3191833 3.1848297l0 18.015549c0 2.4875183 -2.01651 4.5040283 -4.5040283 4.5040283l-192.75572 0c-2.487503 0 -4.5040283 -2.01651 -4.5040283 -4.5040283z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m260.82153 245.37007l0 19.874008",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0d6b46",
    strokeWidth: 4,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m260.82153 245.37007l0 19.874008",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m235.45932 245.37007l0 19.874008",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0d6b46",
    strokeWidth: 4,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m235.45932 245.37007l0 19.874008",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m316.82153 245.37007l0 19.874008",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0d6b46",
    strokeWidth: 4,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m316.82153 245.37007l0 19.874008",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m291.45932 245.37007l0 19.874008",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0d6b46",
    strokeWidth: 4,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m291.45932 245.37007l0 19.874008",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m204.82152 245.37007l0 19.874008",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0d6b46",
    strokeWidth: 4,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m204.82152 245.37007l0 19.874008",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m179.45932 245.37007l0 19.874008",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0d6b46",
    strokeWidth: 4,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m179.45932 245.37007l0 19.874008",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m364.35434 255.30708l0 0c0 -4.487854 3.6381226 -8.125977 8.125977 -8.125977l0 0c2.1551514 0 4.2220154 0.8561249 5.745941 2.3800354c1.5239258 1.5239258 2.3800354 3.590805 2.3800354 5.745941l0 0c0 4.4878693 -3.6381226 8.125992 -8.125977 8.125992l0 0c-4.487854 0 -8.125977 -3.6381226 -8.125977 -8.125992z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0d6b46",
    strokeWidth: 4,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m364.35434 255.30708l0 0c0 -4.487854 3.6381226 -8.125977 8.125977 -8.125977l0 0c2.1551514 0 4.2220154 0.8561249 5.745941 2.3800354c1.5239258 1.5239258 2.3800354 3.590805 2.3800354 5.745941l0 0c0 4.4878693 -3.6381226 8.125992 -8.125977 8.125992l0 0c-4.487854 0 -8.125977 -3.6381226 -8.125977 -8.125992z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m389.41995 255.30708l0 0c0 -4.487854 3.6381226 -8.125977 8.125977 -8.125977l0 0c2.1551514 0 4.2220154 0.8561249 5.745941 2.3800354c1.5239258 1.5239258 2.3800354 3.590805 2.3800354 5.745941l0 0c0 4.4878693 -3.6381226 8.125992 -8.125977 8.125992l0 0c-4.487854 0 -8.125977 -3.6381226 -8.125977 -8.125992z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0d6b46",
    strokeWidth: 4,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m389.41995 255.30708l0 0c0 -4.487854 3.6381226 -8.125977 8.125977 -8.125977l0 0c2.1551514 0 4.2220154 0.8561249 5.745941 2.3800354c1.5239258 1.5239258 2.3800354 3.590805 2.3800354 5.745941l0 0c0 4.4878693 -3.6381226 8.125992 -8.125977 8.125992l0 0c-4.487854 0 -8.125977 -3.6381226 -8.125977 -8.125992z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m299.47992 254.69948l0 0c0 -2.5744324 2.086975 -4.6614227 4.6614075 -4.6614227l0 0c1.2362976 0 2.421936 0.49111938 3.2961426 1.3652954c0.874176 0.8741913 1.3652954 2.059845 1.3652954 3.2961273l0 0c0 2.574417 -2.0870056 4.6614227 -4.661438 4.6614227l0 0c-2.5744324 0 -4.6614075 -2.0870056 -4.6614075 -4.6614227z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0d6b46",
    strokeWidth: 2,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m299.47992 254.69948l0 0c0 -2.5744324 2.086975 -4.6614227 4.6614075 -4.6614227l0 0c1.2362976 0 2.421936 0.49111938 3.2961426 1.3652954c0.874176 0.8741913 1.3652954 2.059845 1.3652954 3.2961273l0 0c0 2.574417 -2.0870056 4.6614227 -4.661438 4.6614227l0 0c-2.5744324 0 -4.6614075 -2.0870056 -4.6614075 -4.6614227z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m243.4786 254.69948l0 0c0 -2.5744324 2.0869904 -4.6614227 4.6614227 -4.6614227l0 0c1.2362823 0 2.4219208 0.49111938 3.296112 1.3652954c0.8741913 0.8741913 1.3652954 2.059845 1.3652954 3.2961273l0 0c0 2.574417 -2.0869904 4.6614227 -4.6614075 4.6614227l0 0c-2.5744324 0 -4.6614227 -2.0870056 -4.6614227 -4.6614227z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0d6b46",
    strokeWidth: 2,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m243.4786 254.69948l0 0c0 -2.5744324 2.0869904 -4.6614227 4.6614227 -4.6614227l0 0c1.2362823 0 2.4219208 0.49111938 3.296112 1.3652954c0.8741913 0.8741913 1.3652954 2.059845 1.3652954 3.2961273l0 0c0 2.574417 -2.0869904 4.6614227 -4.6614075 4.6614227l0 0c-2.5744324 0 -4.6614227 -2.0870056 -4.6614227 -4.6614227z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m187.4786 254.69948l0 0c0 -2.5744324 2.0869904 -4.6614227 4.6614227 -4.6614227l0 0c1.2362823 0 2.4219208 0.49111938 3.296112 1.3652954c0.8741913 0.8741913 1.3652954 2.059845 1.3652954 3.2961273l0 0c0 2.574417 -2.0869904 4.6614227 -4.6614075 4.6614227l0 0c-2.5744324 0 -4.6614227 -2.0870056 -4.6614227 -4.6614227z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0d6b46",
    strokeWidth: 2,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m187.4786 254.69948l0 0c0 -2.5744324 2.0869904 -4.6614227 4.6614227 -4.6614227l0 0c1.2362823 0 2.4219208 0.49111938 3.296112 1.3652954c0.8741913 0.8741913 1.3652954 2.059845 1.3652954 3.2961273l0 0c0 2.574417 -2.0869904 4.6614227 -4.6614075 4.6614227l0 0c-2.5744324 0 -4.6614227 -2.0870056 -4.6614227 -4.6614227z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b6d727",
    d: "m176.82152 366.04724l42.0 -42.0l42.000015 42.0l-21.000015 0l0 183.79529l-42.0 0l0 -183.79529z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1e1e1e",
    strokeWidth: 8,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m176.82152 366.04724l42.0 -42.0l42.000015 42.0l-21.000015 0l0 183.79529l-42.0 0l0 -183.79529z",
    fillRule: "evenodd"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgS2GasMsn);
export default __webpack_public_path__ + "static/media/s2-gas-msn.af871d8869563199dd4cccdff488b634.svg";
export { ForwardRef as ReactComponent };